import type { Maybe } from '@takeshape/util';
import keyBy from 'lodash/keyBy';
import type { ServiceProvider } from '../types.js';
import anthropic from './anthropic-provider.js';
import arize from './arize-provider.js';
import auth0 from './auth0-provider.js';
import awsLambda from './aws-lambda-provider.js';
import azureOpenai from './azure-openai-provider.js';
import bigcommerceCatalog from './bigcommerce-catalog-provider.js';
import bigcommerce from './bigcommerce-provider.js';
import commercelayer from './commercelayer-provider.js';
import contentful from './contentful-provider.js';
import elasticpath from './elasticpath-provider.js';
import fauna from './fauna-provider.js';
import grapqhl from './generic-graphql-provider.js';
import rest from './generic-rest-provider.js';
import googleVertex from './google-vertex-provider.js';
import gorgias from './gorgias-provider.js';
import groq from './groq-provider.js';
import hygraph from './hygraph-provider.js';
import judgeMe from './judge-me-provider.js';
import klaviyo from './klaviyo-provider.js';
import loyaltylion from './loyaltylion-provider.js';
import mailchimp from './mailchimp-provider.js';
import netlify from './netlify-provider.js';
import notion from './notion-provider.js';
import oidc from './oidc-provider.js';
import olyslager from './olyslager-provider.js';
import openAi from './openai-provider.js';
import openapi from './openapi-provider.js';
import petfinder from './petfinder-provider.js';
import portkey from './portkey-provider.js';
import postscript from './postscript-provider.js';
import recharge from './recharge-provider.js';
import reviewsIo from './reviews-io-provider.js';
import riseAiCredit from './rise-ai-credit-provider.js';
import riseAiGifting from './rise-ai-gifting-provider.js';
import salsify from './salsify-provider.js';
import sanity from './sanity-provider.js';
import shipEngine from './ship-engine-provider.js';
import shopify from './shopify-provider.js';
import shopifyStorefront from './shopify-storefront-provider.js';
import stripe from './stripe-provider.js';
import submarine from './submarine-provider.js';
import syndigo from './syndigo-provider.js';
import unstructured from './unstructured-provider.js';
import vercel from './vercel-provider.js';
import voyageai from './voyageai-provider.js';
import wordpress from './wordpress-provider.js';
import yelp from './yelp-provider.js';
import yotpoLoyalty from './yotpo-loyalty-provider.js';
import yotpoUgc from './yotpo-ugc-provider.js';

const providers: Record<string, ServiceProvider> = keyBy(
  [
    grapqhl,
    rest,
    openapi,
    bigcommerce,
    bigcommerceCatalog,
    netlify,
    shopify,
    shopifyStorefront,
    vercel,
    auth0,
    mailchimp,
    klaviyo,
    commercelayer,
    petfinder,
    stripe,
    fauna,
    contentful,
    hygraph,
    awsLambda,
    notion,
    yelp,
    reviewsIo,
    judgeMe,
    shipEngine,
    oidc,
    elasticpath,
    loyaltylion,
    shopify,
    salsify,
    sanity,
    gorgias,
    yotpoUgc,
    yotpoLoyalty,
    postscript,
    riseAiCredit,
    riseAiGifting,
    recharge,
    wordpress,
    openAi,
    voyageai,
    anthropic,
    submarine,
    arize,
    unstructured,
    azureOpenai,
    googleVertex,
    syndigo,
    olyslager,
    groq,
    portkey
  ],
  'name'
);

export function findProvider(providerName: string): Maybe<ServiceProvider> {
  return providers[providerName];
}

export default providers;
